import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../constants';
import { STYLE_VARS } from '../../constants/style-vars';

export const accountStatementStyled = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    // alignItems:'center',
  },
  headerWrapper: {
    width: '100%',
    alignItems: 'center',
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  headerTitle: {
    fontSize: 20,
    color: STYLE_VARS.primaryColor,
  },
  userInfoWrapper: {
    marginVertical: 20,
  },
  userInfoText: {
    fontSize: 20,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.primaryColor,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: 4,
  },
  carInfoText: {
    fontSize: 16,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
  },
  dropdownNote: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 14,
    color: COLORS.DARKER_GREY,
    textTransform: 'uppercase',
    marginBottom: 10,
  },
});
